/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {useTranslation} from 'react-i18next';

import BolmateStatusTile, {StatusTileState} from './bolmateStatusTile';

interface Props {
    state?: StatusTileState;
    onClick?: () => void;
    className?: string;
}

export default function BolmateBolConnectionStatus(props: Props) {
    const {state = 'green', onClick, className} = props;
    const {t} = useTranslation();

    const labels: Record<StatusTileState, string> = {
        green: t('controls.statusTile.bolConnection.green', 'Gekoppeld met Bol'),
        gray: t('controls.statusTile.bolConnection.gray', 'Bol koppeling onbekend'),
        orange: t('controls.statusTile.bolConnection.orange', 'Bol koppeling: waarschuwing'),
        red: t('controls.statusTile.bolConnection.red', 'Geen verbinding met Bol')
    };
    const compactLabels: Record<StatusTileState, string> = {
        green: t('controls.statusTile.bolConnection.greenCompact', 'Gekoppeld'),
        gray: t('controls.statusTile.bolConnection.grayCompact', 'Bol onbekend'),
        orange: t('controls.statusTile.bolConnection.orangeCompact', 'Bol let op'),
        red: t('controls.statusTile.bolConnection.redCompact', 'Niet gekoppeld')
    };

    return (
        <BolmateStatusTile
            className={className}
            label={labels[state]}
            compactLabel={compactLabels[state]}
            state={state}
            onClick={onClick}
        />
    );
}
